import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hire-full-mean-stack-dev',
  templateUrl: './hire-full-mean-stack-dev.component.html',
  styleUrls: ['./hire-full-mean-stack-dev.component.css']
})
export class HireFullMeanStackDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/hire-full-mean-stack-dev/hire-full-mean-stack-dev.component.ts